export const getWholesalerDisplayName = (type, truncate = false, isDemo = false) => {
    switch (type) {
        case 'bluepax_secondary': {
            if (isDemo)
                return 'Secondary #1';
            if (truncate)
                return 'BluPax';
            return 'BluPax Pharma';
        }
        case 'bloodworth_secondary': {
            if (isDemo)
                return 'Secondary #4';
            if (truncate)
                return 'Bloodworth';
            return 'Bloodworth Wholesale';
        }
        case 'capital_secondary': {
            if (isDemo)
                return 'Secondary #2';
            return 'Capital Drug';
        }
        case 'rx_supply_secondary': {
            if (isDemo)
                return 'Secondary #3';
            if (truncate)
                return 'Rx Supply';
            return 'Prescription Supply';
        }
        case 'keysource_secondary': {
            if (isDemo)
                return 'Secondary #5';
            if (truncate)
                return 'KeySource';
            return 'KeySource USA';
        }
        case 'toprx_secondary': {
            if (isDemo)
                return 'Secondary #6';
            if (truncate)
                return 'TopRx';
            return 'TopRx Pharma';
        }
        case 'auburn_secondary': {
            if (isDemo)
                return 'Secondary #7';
            if (truncate)
                return 'Auburn';
            return 'Auburn Generics';
        }
        case 'ipc_secondary': {
            if (isDemo)
                return 'Secondary #8';
            if (truncate)
                return 'IPC';
            return 'IPC Warehouse';
        }
        case 'quest_secondary': {
            if (isDemo)
                return 'Secondary #10';
            if (truncate)
                return 'Quest';
            return 'Quest Pharmaceutical';
        }
        case 'masters_secondary': {
            if (isDemo)
                return 'Secondary #11';
            if (truncate)
                return 'Masters';
            return 'Masters';
        }
        case 'mckesson_primary': {
            if (isDemo)
                return 'Primary #1';
            return 'McKesson';
        }
        case 'cardinal_primary': {
            if (isDemo)
                return 'Primary #2';
            return 'Cardinal Health';
        }
        case 'kinray_primary': {
            if (isDemo)
                return 'Primary #3';
            return 'Kinray';
        }
        // PM-2035: one company, one key. The legacy `amerisource_primary` duplicate is
        // gone; key and display name are both the current brand.
        case 'cencora_primary': {
            if (isDemo)
                return 'Primary #4';
            return 'Cencora';
        }
        case 'morris_dickson_primary': {
            // Stays #6: the demo labels are display-only and renumbering would silently
            // change Morris & Dickson's identity in demo mode. The gap at #5 is harmless.
            if (isDemo)
                return 'Primary #6';
            if (truncate)
                return 'Morris & Dickson';
            return 'Morris & Dickson';
        }
        // PM-2457. Takes #7 rather than filling the #5 gap left by the PM-2035 Cencora
        // dedup — reusing a vacated slot would give an old demo screenshot's "Primary #5" two
        // different meanings depending on when it was taken.
        //
        // PM-2571: this used to share its "Mutual Drug" display name with
        // `mutual_drug_secondary`, which is what put two identically-labelled Mutual Drug rows
        // in admin's Activated Wholesaler Settings panel. The secondary key is gone, so one
        // company now yields exactly one row.
        case 'mutual_drug_primary': {
            if (isDemo)
                return 'Primary #7';
            if (truncate)
                return 'Mutual Drug';
            return 'Mutual Drug';
        }
        default:
            return 'Wholesaler Name';
    }
};
export var PrimaryWholesalerName;
(function (PrimaryWholesalerName) {
    PrimaryWholesalerName["MCKESSON"] = "McKesson";
    PrimaryWholesalerName["CARDINAL_HEALTH"] = "Cardinal Health";
    PrimaryWholesalerName["KINRAY"] = "Kinray";
    PrimaryWholesalerName["AMERISOURCE"] = "Amerisource Bergen";
    PrimaryWholesalerName["SMITH_DRUG"] = "Smith Drug";
    PrimaryWholesalerName["LOUISIANA_WHOLESALE"] = "Louisiana Wholesale Drug";
    PrimaryWholesalerName["MUTUAL_DRUG"] = "Mutual Drug Company";
    PrimaryWholesalerName["MORRIS_DICKSON"] = "Morris Dickson";
    PrimaryWholesalerName["API"] = "API";
    PrimaryWholesalerName["OTHER"] = "Other";
})(PrimaryWholesalerName || (PrimaryWholesalerName = {}));
export var SecondaryWholesalerName;
(function (SecondaryWholesalerName) {
    SecondaryWholesalerName["BLUPAX"] = "Blupax";
    SecondaryWholesalerName["CAPITAL"] = "Capital";
    SecondaryWholesalerName["RXSUPPLY"] = "Prescription Supply";
    SecondaryWholesalerName["BLOODWORTH"] = "Bloodworth";
    SecondaryWholesalerName["KEYSOURCE"] = "Keysource";
    SecondaryWholesalerName["TOPRX"] = "TopRx";
    SecondaryWholesalerName["AUBURN"] = "Auburn";
    SecondaryWholesalerName["IPC"] = "IPC";
    SecondaryWholesalerName["QUEST"] = "Quest Pharmaceutical";
    SecondaryWholesalerName["MASTERS"] = "Masters";
})(SecondaryWholesalerName || (SecondaryWholesalerName = {}));
export const mapPrimaryNameToWholesaler = (primaryName) => {
    if (primaryName === PrimaryWholesalerName.MCKESSON) {
        return 'mckesson_primary';
    }
    if (primaryName === PrimaryWholesalerName.AMERISOURCE) {
        return 'cencora_primary';
    }
    if (primaryName === PrimaryWholesalerName.CARDINAL_HEALTH) {
        return 'cardinal_primary';
    }
    if (primaryName === PrimaryWholesalerName.KINRAY) {
        return 'kinray_primary';
    }
    if (primaryName === PrimaryWholesalerName.MORRIS_DICKSON) {
        return 'morris_dickson_primary';
    }
    // PM-2457. This mapping is load-bearing in a way the `undefined` default hides: admin
    // create-pharmacy's `getPrimaryAccountInfo` (pharmacies.class.ts) treats a missing key as
    // "fall back to McKesson for backward compatibility" and writes the account number to
    // `mckesson_primary.mckessonAccountNumber` with `isPrimary: true`. So the moment Mutual
    // Drug's account-number field was shown on that screen, an unmapped name would have
    // mis-filed the number under a wholesaler the pharmacy does not even use.
    //
    // SMITH_DRUG, LOUISIANA_WHOLESALE, API and OTHER are still deliberately unmapped: they
    // have no storage field, so `PRIMARIES_WITH_ACCOUNT_NUMBER` must never list them. That is
    // also the answer to the ticket's open question about "Other" — no field, because there is
    // nowhere for the value to go that is not somebody else's account number.
    if (primaryName === PrimaryWholesalerName.MUTUAL_DRUG) {
        return 'mutual_drug_primary';
    }
    return undefined;
};
